//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListLoading from '@/components/views/loading'

import BuildingItem from '@/components/business/whole_building_item'

import API from '@/service/whole_buildings'
import Pagination from '@/common/mixins/pagination'

import { App_User } from '@/data/user_info'

import { askAuth, askAuthNavigator } from '@/common/utils/getUserInfo'

const FILTERS = [
    {
        key: 'price_tx',
        query_key: 'total_price',
        label: '价格'
    },
    {
        key: 'zone_tx',
        query_key: 'zone_ids',
        label: '区域'
    },
    {
        key: 'metro',
        query_key: 'metro',
        label: '地铁'
    },
    {
        key: 'layout',
        query_key: 'layout',
        label: '户型'
    },
    {
        key: 'area_tx',
        query_key: 'area',
        label: '面积'
    }
]
export default {
    mixins: [
        Pagination
    ],
    components: {
        ListLoading,
        BuildingItem,


    },
    data () {
        return {
            query: {},
            seek_items: [],
            filters: [],
            subscribed: false,
            notificated: false
        }
    },
    created () {
        const options = this.$route.query
        this.query = options
        console.error(options)
        this.filters = FILTERS.reduce((rs, { label, key, query_key }) => {
            const value = options[key]
            if (value) {
                rs.push({
                    tx: `${label}: ${value}`,
                    key: query_key
                })
            }
            return rs
        }, [])
        this.getData()
    },
    methods: {
        onSubscribe (e) {
            askAuthNavigator(e, '/pages/packageA/consultant_home/main?type=cdgfzzj')
        },
        onNotificate (e) {
            askAuth(e, () => {
                API.notificate(this.getOpt()).then(() => {
                    this.notificated = true
                })
            })
        },
        rmQuery (i) {
            const { key } = this.filters.splice(i, 1)[0]
            console.error(key)
            delete this.query[key]
            this.page = 1
            this.getData()
        },
        getOpt (opt = {}) {
            const { query } = this
            const filter_keys = [
                'decoration',
                'zone_ids',
                'area',
                'total_price',
                'price',
                'layout',
                'metro',
                'status',
                'distance',
                'location',
                'ring_road'
            ]
            filter_keys.forEach((key) => {
                if (query[key]) {
                    opt[key] = query[key]
                }
            })
            return opt
        },
        getData () {
            if (this.seek_items.length && this.page > 1) {
                return
            }
            this.loading = true
            const opt = this.getOpt({
                page: this.page
            })
            API.seek_buildings(opt).then(({ items, recommend }) => {
                if (!recommend) {
                    this.handleData({items})
                } else {
                    this.seek_items = items
                }
                this.loading = false
            }).catch(console.error)
            App_User.get().then((data) => {
                this.subscribed = data.subscribed_weixins && data.subscribed_weixins.indexOf('成都购房者之家') > -1
            })
        },
        goModify () {
            this.$router.back()
        }
    }
}
